import intl from "i18n/messages";
import { tagsColor } from "./constants";
import { cn } from "tools/ui";

const base = "flex my-auto text-[10px] px-2.5 mx-auto";

function GroupTags() {
  const values = Object.entries(tagsColor);
  return (
    <div className="my-auto flex flex-wrap gap-y-2">
      {values.map(([name, color]) => {
        const _name = intl.msgs[`room.${name}`];
        return (
          <div
            key={_name}
            className={cn("flex w-20 rounded-xl mr-2 h-6 border-none", color)}
          >
            <span key={name} title={_name} className={cn(base)}>
              {_name}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default GroupTags;
